import { render, staticRenderFns } from "./EditExcludedUser.vue?vue&type=template&id=39f90cd2"
import script from "./EditExcludedUser.vue?vue&type=script&lang=js"
export * from "./EditExcludedUser.vue?vue&type=script&lang=js"
import style0 from "./EditExcludedUser.vue?vue&type=style&index=0&id=39f90cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports